export default __webpack_public_path__ + "static/media/ElAhlyLogoNoStars.ae16be8e.png";